import { Phone, Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="bg-white p-3 rounded-lg inline-block mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_remodel-pro-6/artifacts/5abucuep_Hernandez%20Remodeling%20Logo.png" 
                alt="Hernandez Remodeling LLC" 
                className="h-20 w-auto object-contain"
              />
            </div>
            <p className="text-gray-400 leading-relaxed">
              Family-owned remodeling company serving Central Virginia since 2015. 
              We transform homes with quality craftsmanship, honest communication, and dependable service.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/"
                  className="text-gray-400 hover:text-crimson-500 transition-colors"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link 
                  to="/services"
                  className="text-gray-400 hover:text-crimson-500 transition-colors"
                >
                  Services
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact"
                  className="text-gray-400 hover:text-crimson-500 transition-colors"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-crimson-500 flex-shrink-0 mt-1" />
                <a href="tel:5404235754" className="text-gray-400 hover:text-crimson-500 transition-colors">
                  (540) 423-5754
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-crimson-500 flex-shrink-0 mt-1" />
                <a href="mailto:hernandezremodeling81@gmail.com" className="text-gray-400 hover:text-crimson-500 transition-colors break-all">
                  hernandezremodeling81@gmail.com
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-crimson-500 flex-shrink-0 mt-1" />
                <span className="text-gray-400">
                  Gordonsville, VA<br />
                  Serving Central Virginia
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-gray-400 text-sm">
            © {currentYear} Hernandez Remodeling LLC. All rights reserved.
          </p>
          <p className="text-gray-400 text-sm">
            Serving Central Virginia Since 2015
          </p>
        </div>
      </div>
    </footer>
  );
};
